import Vue from 'vue'
import VueRouter from "vue-router"
import VueSweetAlert from 'vue-sweetalert'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import DatatableFactory from 'vuejs-datatable/dist/vuejs-datatable.esm'
import {store} from './store'
import API from './api'
import axios from 'axios'
import * as VueGoogleMaps from 'vue2-google-maps'
import Geocoder from "@pderas/vue2-geocoder"


import App from './App.vue'
import Login from './components/login/Layout'

//Menu Dashboard
import Obras from './components/obras/Obras.vue'
import Dashboard from './components/dashboard/Dashboard.vue'
import Mapas from './components/mapas/Mapas.vue'

//Menus internos
import Padrao from './components/layouts/Padrao'
import Usuario from './components/usuario/UsuarioEditar'
import TipoObrasListagem from './components/obras/TipoObrasListagem.vue'
import TipoServicosListagem from './components/servicos/TipoServicosListagem.vue'
import ConveniosListagem from './components/convenios/ConveniosListagem.vue'
import MedicoesListagem from './components/medicoes/MedicoesListagem.vue'
import AreasListagem from './components/areas/AreasListagem.vue'
import SituacoesListagem from './components/situacoes/SituacoesListagem.vue'
import TipoExecucoes from './components/execucoes/TipoExecucoes.vue'


Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueSweetAlert)
Vue.use(VueTheMask)
Vue.use(money, {precision: 2})
Vue.use(DatatableFactory)
Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyCV5oMO7N9H3nZhUzZz4Tiw05c5dxRI0XU',
      libraries: 'places', // This is required if you use the Autocomplete plugin

    }
})
Vue.use(Geocoder, {
    defaultCountryCode: 'BR',
    defaultLanguage:    'pt',
    defaultMode:        'address',
    googleMapsApiKey:   'AIzaSyCV5oMO7N9H3nZhUzZz4Tiw05c5dxRI0XU'
})

window.axios = axios;
window.API = API;
window.Store = store;

axios.defaults.baseURL = 'https://hapi.cotia.llie.ge';

if (Store.state.logado) {
    let token = Store.getters.pegaAccessToken;
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export const router = new VueRouter({
    mode: 'history',
    baseUrl: process.env.NODE_ENV === 'production',
    base: process.env.BASE_URL,
    routes: [
        //Menus Dashboard
        {path: '/', component: Padrao,
            children: [
                {
                    path: '/dashboard',
                    alias: '',
                    component: Obras,
                    name: 'Inicio'
                }
            ]},
        {path: '/login', component: Login},
        {path: '/', component: Padrao, children: [
                {
                    path: 'obras',
                    alias: '',
                    component: Obras,
                    name: 'Obras'
                }
            ]},
        {path: '/', component: Padrao, children: [
                {
                    path: 'cadastros-basicos',
                    alias: '',
                    component: ConveniosListagem,
                    name: 'Inicio'
                }
            ]},

        //Menus Internos
        {path: '/tipo-obras', component: Padrao, children: [
                {
                    path: 'listagem',
                    alias: '',
                    component: TipoObrasListagem,
                    name: 'Tipo Obras'
                }
            ]},
        {path: '/tipo-servicos', component: Padrao, children: [
                {
                    path: 'listagem',
                    alias: '',
                    component: TipoServicosListagem,
                    name: 'Tipo Servicos Listagem'
                }
            ]},
        {path: '/convenios', component: Padrao, children: [
                {
                    path: 'listagem',
                    alias: '',
                    component: ConveniosListagem,
                    name: 'Convenios'
                }
            ]},
        {path: '/obras', component: Padrao, children: [
                {
                    path: 'listagem',
                    alias: '',
                    component: Obras,
                    name: 'Obras'
                }
            ]},
        {path: '/medicoes', component: Padrao, children: [
                {
                    path: 'listagem',
                    alias: '',
                    component: MedicoesListagem,
                    name: 'Medições'
                }
            ]},
        {path: '/areas', component: Padrao, children: [
                {
                    path: 'listagem',
                    alias: '',
                    component: AreasListagem,
                    name: 'Áreas'
                }
            ]},
        {path: '/situacoes', component: Padrao, children: [
                {
                    path: 'listagem',
                    alias: '',
                    component: SituacoesListagem,
                    name: 'Tipo de Situações'
                }
            ]},
        {path: '/tipo-execucoes', component: Padrao, children: [
                {
                    path: 'listagem',
                    alias: '',
                    component: TipoExecucoes,
                    name: 'Tipo de Execuções'
                }
            ]},

        {
            path: '/usuario',
            component: Padrao,
            children: [
                {
                    path: 'editar',
                    alias: '',
                    component: Usuario,
                    name: 'Usuario'
                }
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    const publicPag = ['/login', '/cadastro'];
    const authReq = !publicPag.includes(to.path);

    if (authReq && !Store.state.logado) {
        return next('/login');
    }

    next();
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
